import React from 'react';
import { CompactMapSkeleton } from '@/experiences/sales-portal/components/map/compact-map-skeleton';
import { createStyles } from '@/contexts/theme-context';
import {
  DEFAULT_ZOOM,
  MAP_OPTIONS,
} from '@/experiences/sales-portal/components/map/map-options.web';
import { GOOGLE_MAPS_LOADER_OPTIONS } from '@usepepper/ui/molecules/map/loader-options';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { MAP_COMPACT_SIZE } from '@/experiences/sales-portal/components/map/constants';
import { MapDotMarker } from '@/experiences/sales-portal/components/map/map-dot-marker';
import { MapPlaceholder } from '@/experiences/sales-portal/components/map/map-placeholder';
import { MapProps } from '@/experiences/sales-portal/components/map/types';

export const CompactMap: React.FC<MapProps> = React.memo(
  ({ coordinate, markers }) => {
    const [styles] = useStyles();

    const { isLoaded } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);

    if (!coordinate) {
      return <MapPlaceholder />;
    }

    const center = {
      lat: coordinate.latitude,
      lng: coordinate.longitude,
    };

    if (!isLoaded || typeof google === 'undefined') {
      return <CompactMapSkeleton />;
    }

    return (
      <GoogleMap
        center={center}
        mapContainerStyle={styles.mapContainer}
        options={MAP_OPTIONS}
        zoom={DEFAULT_ZOOM}
      >
        {markers?.map((marker) => (
          <MapDotMarker
            key={`map-marker-${marker.coordinate.latitude}:${marker.coordinate.longitude}`}
            marker={marker}
          />
        ))}
      </GoogleMap>
    );
  },
);

const useStyles = createStyles((theme) => ({
  mapContainer: {
    borderRadius: theme.sk.radii.radiusLarge,
    flexShrink: 0,
    height: MAP_COMPACT_SIZE,
    overflow: 'hidden',
    width: MAP_COMPACT_SIZE,
  },
}));
